module.exports = __webpack_public_path__ + "static/img/fontawesome-webfont.acf3dcb.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 366
// module chunks = 4